import ApiService from "vamos/cockpit/base/services/type/ApiService";
import { ResponseStatusMessage } from "vamos/cockpit/model/api/vamos.private.api.types";
import { showStatusMessage } from "vamos/cockpit/base/handler/MessageToastHandler";

type GuidsPayload = {
  all: boolean,
  supplierConditionGuid?: string,
  productGuids: string[],
};

export default class RequiredStockService {
  public static async createRequiredOrders(guidsPayload: GuidsPayload) {
    const json = await ApiService.getInstance().postRestJsonData("/stock/create-required-orders", guidsPayload);
    const responseData = json?.data as ResponseStatusMessage;
    const result = responseData.content;

    showStatusMessage(result)
  }
}